import React from "react";
import "../pages/Home.css";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div id="container">
      {/* ===== Header ===== */}
      <header className="header">
        {/* Left Logo */}
        <div className="logo">
          <img
            src={`${process.env.PUBLIC_URL}/images/sj1.jpg`}
            alt="Grampanchayat Logo"
          />
        </div>

        {/* Center Title + ISO */}
        <div className="header-title">
          <h1>गट ग्रामपंचायत खापरी-उबगी</h1>
          <h2>पंचायत समिती कळमेश्वर, जिल्हा परिषद नागपूर</h2>
          <h3>महाराष्ट्रातील एकमेव ISO प्रमाणित ग्रामपंचायत उपक्रम</h3>

          <div className="iso-section">
            <img
              src={`${process.env.PUBLIC_URL}/images/iso.png`}
              alt="ISO Certified"
            />
            <span>ISO Certified Organization</span>
          </div>
        </div>

        {/* Right Side Saints Photos */}
        <div className="saints-photos">
          <img src={`${process.env.PUBLIC_URL}/images/raje.jpg`} alt="शिवाजी महाराज" />
          <img src={`${process.env.PUBLIC_URL}/images/Gadgemaharaj.jpg`} alt="गाडगे महाराज" />
          <img src={`${process.env.PUBLIC_URL}/images/tukdojimaharaj.jpg`} alt="तुकोजी महाराज" />
        </div>
      </header>

      <div className="marquee-box">
        <div className="marquee-text">
          गट ग्रामपंचायत खापरी-उबगी – तालुका कळमेश्वर – जिल्हा नागपूर
        </div>
      </div>



      {/* ===== Main Menu ===== */}
      <nav className="menuicons main-menu">
        <ul>
          <li><Link to="/aboutus">About Us</Link></li>
          <li><Link to="/">मुखपृष्ठ</Link></li>
          <li><Link to="/gramsevakpage">ग्रामपंचायत अधिकारी</Link></li>
          <li><Link to="/sarpanch">सरपंच कार्यकाल</Link></li>
          <li><Link to="/upsarpanch">उपसरपंच कार्यकाल</Link></li>
          <li><Link to="/vikas">विकास कामे</Link></li>
          <li><Link to="/team">सदस्य/कर्मचारी</Link></li>
        </ul>
      </nav>

      {/* ===== Sub Menu ===== */}
      <nav className="menuicons sub-menu">
        <ul>
          <li><Link to="/janmdakhala">जन्म दाखला</Link></li>
          <li><Link to="/death">मृत्यू दाखला</Link></li>
          <li><Link to="/vivah">विवाह दाखला</Link></li>
          <li><Link to="/gallery">Gallery</Link></li>
          <li><Link to="/sabha">सभेची माहिती</Link></li>
          <li><Link to="/contact">संपर्क करा</Link></li>
          <li><Link to="/sadasya">सदस्य कार्यकारणी</Link></li>
        </ul>
      </nav>

      {/* ===== Auto Image Slider (आता खरोखर एकावेळी एक फोटो) ===== */}
      <div className="auto-slider">
        <div className="auto-slider-inner">
          <img src={`${process.env.PUBLIC_URL}/images/slide5.jpg`} alt="Slide 1" />
          <img src={`${process.env.PUBLIC_URL}/images/slide1.jpg`} alt="Slide 1" />
          <img src={`${process.env.PUBLIC_URL}/images/slide2.jpg`} alt="Slide 2" />
          <img src={`${process.env.PUBLIC_URL}/images/slide3.jpg`} alt="Slide 3" />
          <img src={`${process.env.PUBLIC_URL}/images/slide4.jpg`} alt="Slide 4" />
        </div>
      </div>

      {/* ===== Main Section - Team Table ===== */}
      <main>
        <h3 className="style2">कार्यकारी मंडळ गट ग्रामपंचायत खापरी-उबगी</h3>

        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>नाव</th>
                <th>पद</th>
                <th>फोन नं.</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["1", "सौ मधुमती देवदास तागडे", "सरपंच", "8554915167"],
                ["2", "श्री सचिन ज्ञानेश्वर आत्राम", "उपसरपंच", "9158380385"],
                ["3", "श्री रितेश सीताराम परवकर", "सदस्य", "9881555076"],
                ["4", "श्री सुशील देवमन धोटे", "सदस्य", "7875132722"],
                ["5", "श्री हरिचंद पुंडलिक इखनकर", "सदस्य", "9284085292"],
                ["6", " सौ मालती गजानन झाडे", "सदस्य", "9921615579"],
                ["7", " सौ बेबी बलदेव सरोदे", "सदस्य", "9049481078"],
                ["8", "सौ संगीता परमेश्वर धुर्वे", "सदस्य", "8459061439"],
                ["9", "सौ मोनिका प्रशांत आवारी", "सदस्य", "9730334121"],
                ["10", " सौ कीर्ती आशिष आत्राम", "सदस्य", "7722061973"],
                ["11", " श्री अजित ज्ञानेश्वर आत्राम", "ग्रामपंचायत कर्मचारी", "9763533928"],
                ["12", "श्री सुजित सुरेश आवारी", "पाणी पू. कर्माचारी", "7745013370"],
                ["13", "श्री चंद्रशेखर शेषराव तागडे", "ग्रामपंचायत रोजगार सेवक", "8806589376"],
                ["14", "सौ. मनिषा किशोर मोजणकर", "संगणक ऑपरेटर", "--"],
              ].map((row, index) => (
                <tr key={index} className={index % 2 === 0 ? "even-row" : ""}>
                  {row.map((cell, i) => (
                    <td key={i}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>

      {/* ===== Footer ===== */}
      <footer className="footer-section">
        <ul className="social-icons">
          <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/Facebook_logo_(square).png`} alt="Facebook" /></a></li>
          <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/Logo_of_Twitter.png`} alt="Twitter" /></a></li>
          <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/instagaram.webp`} alt="Instagram" /></a></li>
          <li><a href="https://youtube.com" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/youtube.png`} alt="YouTube" /></a></li>
        </ul>

        <p className="footer-links">
          <Link to="/copyright">Copyright Policy</Link> | <Link to="/disclaimer">Disclaimer</Link> | <Link to="/privacy">Privacy Policy</Link> | <Link to="/contact">Contact Us</Link>
        </p>

        <p>
          Website Designed, Designed & Developed by NexGen BR Technologies Pvt. Ltd.
Content provided by Grampanchayat Office, Government of Maharashtra
© 2026 [Client Company Name]. All Rights Reserved. | Designed & Developed by NexGen BR Technologies Pvt. Ltd.
Technical issues and updates may require some time for resolution. 7038278133
        </p>


        <div className="footer-logos">
          <a href="https://swachhbharatmission.ddws.gov.in" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/swachh-bharat.png`} alt="Swachh Bharat" /></a>
          <a href="https://digitalindia.gov.in" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/digital-india-logo.png`} alt="Digital India" /></a>
          <a href="https://data.gov.in" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/data-gov-logo.png`} alt="Data Portal" /></a>
          <a href="https://india.gov.in" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/portal.jpg`} alt="National Portal" /></a>
          <a href="https://mygov.in" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/mygov.png`} alt="MyGov" /></a>
          <a href="https://meity.gov.in" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/Meity_logo.png`} alt="MeitY" /></a>
          <a href="https://pmindia.gov.in" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/pm-india-logo.jpg`} alt="PM India" /></a>
        </div>
      </footer>
    </div>
  );
};

export default Home;